<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">我的好友</div>
      <div class="nav-right">
        <span class="nav-lable" @click="delete_friend()">删除</span>
        <img src class="nav-img none" />
      </div>
    </div>

    <ul class="friend-block" v-for="(item,index) in my_friend" :key="index" >
      <li :class="{move:candelete.id==item.id}" @touchstart="touchStart(item)"  @touchend="touchEnd(item)">
          <div class="ub ub-pc friend-item">
            <img :src="item.photo" class="friend-img" />
            <div class="friend-info ub ub-ver ub-f1">
              <div class="friend-name ub">
                <span>{{ item.nick }}</span>
                <div class="age">
                  <span>{{ item.age_range }}</span>
                </div>
              </div>
              <div class="num">
                <span>豪气值: <label>{{ item.total_coin }}</label></span>
                <span>魅力值: <label>{{ item.total_score }}</label></span>
              </div>
            </div>
            <div class="btn-block ub ub-ver ub-pc ub-ac">
              <div class="day-online ub ub-pc">
                <div class="tips-state state1" v-if="item.dtm_sp <= 1 *24"></div>
                <div class="tips-state state2" v-if="item.dtm_sp > 1 *24 && item.dtm_sp <= 2 *24"></div>
                <div class="tips-state state3" v-if="item.dtm_sp > 2 *24 && item.dtm_sp <= 30 *24"></div>
                <div class="tips-state state4" v-if="item.dtm_sp > 30 *24"></div>
                <span>{{ item.dtm_txt }}</span>
              </div>
              <div class="btn ub ub-pc ub-ac" @click="goto_chart(item.uid)">
                <span>聊天</span>
              </div>
            </div>
          </div>

          <div class="del" @click="deleteItem(index)">删除</div>
          <div class="menu-line"></div>
        </li>
      </ul>

    <div class="ub ub-pc ub-ac"  v-if="my_friend.length > 0 && my_friend.length % size == 0">
      <div class="ub ub-ac ub-pc btn" @click="load_more()"><span>加载更多</span></div>
    </div>

    <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="notData">
        <img src="../assets/img/new2024/no-friends.png" alt="">
        <span class="tip-404">暂无好友</span>
        <div class="btn-404" @click="goto_msg()"><span>添加好友</span></div>
    </div>

    <alert ref="myConfirm" ></alert>
  </div>
</template>

<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
import Alert from "../components/Form.vue";
export default {
  components: {
    alert: Alert
  },
  data() {
    return {
      my_friend: [],
      clientNum: {}, // 记录开始滑动（x1）,结束滑动（x2）的鼠标指针的位置
      candelete: {}, // 滑动的item
      index: 0,
      size: 10,
      notData: false,
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_getFriend"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    init_page() {
      var my_friends = this.$store.state.http_cache.my_friends;
      
      if (my_friends.dtm != "") {
        if (my_friends.data_serve.length == 0) {
          this.notData = true;
        }
        var dtm = my_friends.dtm;
        var dtm_now = new Date().getTime();

        var tsp = dtm_now - dtm;
        var ss = Math.floor(tsp / 1000);
        if (ss < 60) {
          this.my_friend = my_friends.data_serve;
          return false;
        }
      }
      this.load_more();
    },

    load_more() {

      //计算index
      var index = parseInt(this.my_friend.length / this.size);
      if (index > this.index || (index == 0 && this.my_friend.length == 0)) {
        this.index = index;
      } else {
        this.$toast.center("没有更多了~");
        return false;
      }

      //加载数据(按条数加载)
      var uid = this.$store.state.uid;
      var self = this;
      this.$loading("正在加载中...");
      self.get({
        url:
          "/App/GetFriends3/?uid=" + uid + "&index=" + this.index + "&size=" +  this.size,
        success: function (data) {
          self.$loading.close();
          // console.log(JSON.stringify(data));
          if (data.length == 0) {
            self.notData = true;
          }

          for(var i=0; i<data.length; i++){
            data[i].photo=self.$store.state.url + "/photo/" +data[i].photo;
            data[i].id=i+1;
            var dtm = data[i].least_time;
            var sp = self.dateDiff2(dtm);
            var dtm_txt = "";
            if (sp < 1) {
              dtm_txt = "刚刚";
            }
            if (sp >= 1 && sp <= 1 *24) {
              dtm_txt = sp + "小时前";
            }
            if (sp > 1 *24 && sp <= 2 *24) {
              dtm_txt = "昨日在线";
            }
            if (sp > 2 *24 && sp <= 30 *24) {
              var diffdays= sp / 24;
              diffdays =  parseInt(diffdays);
              dtm_txt = diffdays + "天前";
            }
            if (sp > 30 *24) {
              dtm_txt = "很久没来";
            }

            data[i].dtm_sp = sp;
            data[i].dtm_txt = dtm_txt;
          }
          
            self.my_friend = self.my_friend.concat(data);

            var obj = {
                dtm: new Date().getTime(),
                data_serve: self.my_friend
            }
            self.$store.commit("set_http_cache", {my_friends: obj});
        },
      });
    },

    //计算好友的在线时间差
    dateDiff2 (dtm){
      var dtm_now = new Date();
      dtm= dtm.replace(/-/g,"/");
      
      dtm = new Date(dtm);


      //将时间计算相差的毫秒
      var diffMs = dtm_now.getTime() - dtm.getTime();

      //将毫秒转化为天数差
      var diffHours= diffMs / (1000 * 60 * 60);

      diffHours = parseInt(diffHours);
      
      return diffHours;

    },

    //处理ios时间格式
    diffIos(dateString) {
        var iosDate = "";
        var date = new Date(dateString);

        // 获取年份、月份、日期、小时、分钟和秒
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');

        // 格式化日期和时间
        var iosDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

        return iosDate;
    },

    goto_chart(uid) {
      this.$router.push({ name: "chart", params: { uid: uid } });
    },
    goto_msg() {
      this.$router.push({name: "msg"});
    },

    delete_friend(){
      var h =
        '<div style="display: flex; flex-direction: column; font-size:.9rem; overflow:scroll;width: 99.5%;border-radius:.3em;color: #888;">' +
        "<span>按住想要删除的好友向左滑动，点击删除即可</span>" +
        "<img src='http://appdata.jscx666.cn/img/other/19.png' />" +
        '</div>';
      this.$refs.myConfirm.show(h, {
        type: "alert",
        confirmText: "确定",
        titleText: "删除好友",
        data: ""
      });

    },

    

    /**
     * 删除item
     * index是下标
     */
    deleteItem(index) {
      //发往后台进行删除
      var u = this.my_friend[index];
      var uid = u.uid;
      var uid_cur = this.$store.state.uid;

      var self = this;
      this.get({
        url: "/App/Remove_Friends/?uid=" + uid + "&uid_cur=" + uid_cur,
        success: function (data) {
          // console.log(JSON.stringify(data));
          if (data.state == "1") {
            self.act_getFriend(uid_cur);
            self.my_friend.splice(index, 1);
          }
        },
      });
      
      // splice方法是删除数组某条数据，或者向某个位置添加数据

      //保存删除好友
      tool.set_delete_friends(uid);
    },
    touchStart(item) {
      let touchs = event.changedTouches[0];
      // 记录开始滑动的鼠标位置
      this.clientNum.x1 = touchs.pageX;
      this.candelete = {};
    },
    touchEnd(item) {
      let touchs = event.changedTouches[0];
      // 记录结束滑动的鼠标位置
      this.clientNum.x2 = touchs.pageX;
      this.candelete = {};
      // 判断滑动距离大于50，判定为滑动成功，否则失败
      if (
        this.clientNum.x2 < this.clientNum.x1 &&
        Math.abs(this.clientNum.x1) - Math.abs(this.clientNum.x2) > 50
      ) {
        //event.preventDefault();
        this.candelete = item;
      } else if (
        this.clientNum.x2 > this.clientNum.x1 &&
        Math.abs(this.clientNum.x2) - Math.abs(this.clientNum.x1) > 10
      ) {
        //event.preventDefault();
        this.candelete = {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #FDFDFD;
  
  .nav-right {
    padding-right: 0.5rem;
    .nav-lable {
      margin: 0;
      font-size: 0.9rem;
      color: #fff;
    }
  }

  .btn {
    margin: 1rem 0;
    padding: 0.5rem 8rem;
    border-radius: 2rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

  .no-404 {
    margin-top: 10rem;
    background-size: 100% 100%;
    .tip-404 {
      margin-top: 1rem;
      font-size: 0.75rem;
    }
    .btn-404 {
      margin-top: 1rem;
      padding: 0.5rem 1rem;
      border-radius: 1rem;
      background: linear-gradient( 90deg, #A264E7 0%, #FE9CC0 100%);
      span {
        font-size: 0.9rem;
        color: #FFFFFF;
      }
    }
  }
}

.friend-block {
  overflow-x: hidden; /*隐藏ul x轴的滚动条*/
  padding: 0;
  margin: 0;
  li {
    position: relative;
    transform: translateX(0);
    transition: all 0.3s; /*滑动效果更生动*/
    list-style: none;
  }
  li.move {
    transform: translateX(-8em); /*滑动后x轴位移-60px,使其可见*/
  }
  .del {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: -1px;
    z-index: 3;
    width: 8em;
    height: 100%;
    text-align: center;
    color: #fff;
    background-color: #ff5b45;
    transform: translateX(8em); /*默认x轴位移60px，使其隐藏*/
  }
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }
}

.friend-item {
    padding: 0.5rem 0.8rem;
    .friend-img {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
    }
    .friend-info {
      margin-left: 1rem;
      .friend-name {
        span {
          font-size: 0.9rem;
          font-weight: bold;
          color: #333;
        }
        .age span{
          padding: 0.2rem 0.5rem;
          margin-left: 0.5rem;
          font-size: 0.65rem;
          color: #666;
          border: 1px solid #dcdcdc;
          border-radius: 1rem;
        }
      }
      .num {
        margin-top: 0.5rem;
        span {
          font-size: 0.75rem;
          color: #333;
          label {
            font-size: 0.65rem;
            font-weight: bold;
            color: #BA61FF;
          }
        }
      }
      .num span:last-child{
        margin-left: 1rem;
      }
    }
    .btn-block {
      .day-online {
        .tips-state {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          
        }
        .state1 {
          background-color: #2AE459;
        }
        .state2 {
          background: rgba(52,199,89,0.6);
        }
        .state3 {
          background: rgba(52,199,89,0.3);
        }
        .state4 {
          background-color: #C1C1C1;
        }
        span {
          margin-left: 0.2rem;
          font-size: 0.5rem;
          color: #333;
        }
      }
      .btn {
        margin-top: 0.5rem;
        padding: 0.2rem 1rem;
        background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
        border-radius: 1rem;
        span {
          font-size: 0.75rem;
          color: #fff;
        }
      }
    }
  }

.container-dark {
  background-color: #2F2E33;
  .friend-block {
    .friend-item {
      .friend-info {
        .friend-name {
          span {
            color: #FDFDFD;
          }
        }
        .num {
          span {
            color: #FDFDFD;
          }
        }
      }
      .btn-block {
        .day-online {
          span {
            color: #FDFDFD;
          }
        }
      }
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
  .no-404 {
    .tip-404 {
      color: #dfdfdf;
    }
  }
}
</style>
